import React from 'react';
import HomeHero from './HomeHero';
import HomeFirst from './HomeFirst';
import HomeSecond from './HomeSecond';
import HomeThird from './HomeThird';
import SEOHead from '../../seo/SEOHead';
import { seoConfig } from '../../seo/seoConfig';
import { serviceSchema, generateBreadcrumbs } from '../../seo/structuredData';

const Home: React.FC = () => {
  return (
    <div className="home">
      <SEOHead
        {...seoConfig.home}
        structuredData={[
          serviceSchema,
          generateBreadcrumbs([{ name: 'Home', url: 'https://www.styror.com/' }]),
        ]}
      />
      <HomeHero />
      <HomeFirst />
      <HomeSecond />
      <HomeThird />
    </div>
  );
};

export default Home;